import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  passwordCriteria: {
    padding: 25,
    marginTop: 25,
    fontSize: 16,
    letterSpacing: '-0.5px',
    backgroundColor: '#fbfbfb',
    color: '#4a4a4a',
    '@media(max-width: 480px)': {
      padding: 15,
      marginTop: 15,
    },
    '& ul, & ul li': {
      padding: 0,
      margin: 0,
      listStyle: 'none'
    },
    '& h3, & ul li': {
      padding: 0,
      fontSize: 16,
      margin: '0 0 8px 0',
      lineHeight: '22px',
      '& svg': {
        verticalAlign: 'middle',
        fontSize: '100%',
        width: '1em',
        height: '1em',
        color: '#e8e8e8',
        marginRight: 6,
        fill: 'currentColor'
      },
      '&.valid svg': {
        color: '#a5d36b'
      }
    },
    '& ul li:last-child': {
      marginBottom: 0,
    }
  },
});
